import React, { useEffect, useState } from "react";
import "./WhitelistTemplate.css";
import Swal from "sweetalert2";
import { Messante_URL } from "./apiConfig";
import { Link } from "react-router-dom";

const TemplateWhitelist = ({ onViewTemplates }) => {
    const [fileType, setFileType] = useState("CSV");
    const [templateType, settemplateType] = useState("Impicit");
    const [showprogress, setshowprogress] = useState(false);
    const [senderAPIData, setsenderAPIData] = useState([]);
    const [formData, setFormData] = useState({
        userId: "",
        senderId: "",
        templateName: "",
        templateId: "",
        templateText: "",
        operatorCreateTime: "",
    });

    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;

    const [bulkData, setBulkData] = useState({
        userId: "",
        operatorId: "",
        file: null,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleBulkChange = (e) => {
        const { name, value } = e.target;

        setBulkData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];

        if (file) {
            setBulkData((prev) => ({
                ...prev,
                file,
            }));
        }
    };

    const getCurrentDateTime = () => {
        const now = new Date();
        const yy = String(now.getFullYear()).slice(-2);
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const dd = String(now.getDate()).padStart(2, "0");
        const hh = String(now.getHours()).padStart(2, "0");
        const min = String(now.getMinutes()).padStart(2, "0");
        const sec = String(now.getSeconds()).padStart(2, "0");

        return `${yy}-${mm}-${dd} ${hh}:${min}:${sec}`;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("sender:", formData.senderId);
        console.log("templateid:", formData.templateId);
        console.log("templatename:", formData.templateName);
        console.log("templateText:", formData.templateText);
        console.log("templateType:", formData.templateType);
        if (!formData?.senderId || !formData?.templateId || !formData?.templateName || !formData?.templateText || !templateType) {
            setshowprogress(false);
            const re = await Swal.fire({
                title: "Value Error!",
                text: "Please fill all Required fields. Some field(s) are missing.",
                icon: "error",
                allowOutsideClick: false
            });
        }

        else {
            try {
                setshowprogress(true)
                const apiUrl = `${Messante_URL}/template`;
                const requestBody = {
                    userID: sessionusername,
                    autoSNId: senderAPIData?.find((i) => i?.sender === formData?.senderId)?.autosnid || "",
                    sender: formData?.senderId,
                    smsTemplateID: formData?.templateId,
                    smsText: formData?.templateText,
                    templateName: formData?.templateName,
                    templateType: formData?.templateType === "promotional" ? "PROMOTIONAL" : formData?.templateType,
                    activityByUserId: sessionusername,
                    operatorCreatTime: getCurrentDateTime(),
                    parentuid: sessionusername
                }

                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                };

                // API Request
                const response = await fetch(apiUrl, fetchOptions);
                const data = await response.json();
                if (data.status === "Success" || data.errorCode === "000") {
                    setshowprogress(false);
                    const re = await Swal.fire({
                        title: "Success",
                        text: data.errorDesc,
                        icon: "success"
                    });
                }

                else {
                    setshowprogress(false);
                    await Swal.fire({
                        title: `Template Whitelisting Error`,
                        text: data.errorDesc || "Something went wrong",
                        icon: "error"
                    });
                }
            }

            catch (error) {
                console.error("API Request Error:", error.message);
                setshowprogress(false);

                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: error.message,
                    icon: 'error'
                });
            }
        }
    };

    const handleBulkSubmit = async (event) => {
        event.preventDefault();
        if (!bulkData?.file) {
            //setshowprogress(false);
            const re = await Swal.fire({
                title: "Value Error!",
                text: "Please fill all Required fields. Some field(s) are missing.",
                icon: "error",
                allowOutsideClick: false
            });
        }

        else {
            try {
                setshowprogress(true)
                const apiUrl = `${Messante_URL}/bulktemplate`;
                const formData = new FormData();

                // Append vuser as a JSON string
                formData.append("sender", "All");
                formData.append("senderType", "0");
                formData.append("userID", sessionusername);
                formData.append("operatorid", "SmartPing");
                formData.append("peid", "All");
                formData.append("activityByUserId", sessionusername);
                formData.append("file", bulkData?.file);
                formData.append("parentuid", sessionusername);

                const uploadResponse = await fetch(apiUrl, {
                    method: "POST",
                    body: formData,
                });

                const result = await uploadResponse.json();
                console.log("result:", result);
                if (result.status === "Success" || result.errorCode === "000") {
                    setshowprogress(false);
                    const re = await Swal.fire({
                        title: "Success",
                        html: result.errorDesc.replace(/;/g, "<br>"),
                        icon: "success"
                    });

                    if (re.isConfirmed) {

                    }
                }

                else {
                    setshowprogress(false);
                    const formatted = (result.errorDesc || "Something went wrong")
                        .replace(/;/g, "<br>");
                    const re = await Swal.fire({
                        title: `Bulk Template Whitelist Error`,
                        html: formatted,
                        icon: "error"
                    });

                    if (re.isConfirmed) {

                    }
                }
            }

            catch (error) {
                console.error("API Request Error:", error.message);
                setshowprogress(false);

                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: error.message,
                    icon: 'error'
                });
            }
        }
    };

    const handleCancel = () => {
        setFormData({
            userId: "",
            senderId: "",
            templateName: "",
            templateId: "",
            templateText: "",
            operatorCreateTime: "",
        });

        setBulkData({
            userId: "",
            operatorId: "",
            file: null,
        });
    };

    const callDistinctSenderUserwise = async () => {

        try {
            const apiUrl = `${Messante_URL}/sender?uid=${sessionusername}&callfor=viewless&activityBy=${sessionusername}`;
            const fetchOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            };

            // API Request
            const response = await fetch(apiUrl, fetchOptions);
            const data = await response.json();

            setshowprogress(false);
            if (data.status === "Success" || data.errorCode === 0) {
                const TemplateData = Array.isArray(data?.sndlist) ? data?.sndlist : [];
                setsenderAPIData(TemplateData);
            }

            else {
                const errorMessage = data?.status;
                const responseBody = await data?.errorDesc;
                setshowprogress(false);


                // const result = await Swal.fire({
                //     title: 'View All Senders Error',
                //     html: `${errorMessage}${responseBody}`,
                //     icon: 'error'
                // });

                setsenderAPIData([]);
            }

        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
        }



    }

    useEffect(() => {
        callDistinctSenderUserwise();
    }, []);

    return (
        <div className="template-page">

            {/* PAGE HEADER */}
            <div className="template-page-header">
                <div>
                    <h2>Template Whitelisting</h2>
                    <p>Manage and whitelist communication templates</p>
                </div>

                <Link
                    className="view-template-btn"
                    to="/viewtemplatewhitelisted"                >
                    <span className="view-icon">▤</span>
                    View Whitelisted Templates
                </Link>
            </div>


            {/* MAIN FORMS */}
            <div className="template-form-grid">

                {/* ================= ONE BY ONE ================= */}
                <div className="template-card">

                    <div className="template-card-title">
                        Whitelisting Template
                        <span>[ One By One ]</span>
                    </div>

                    <div className="template-card-body">
                        <div className="sender-form-group template-field">
                            <label>
                                Template Type
                            </label>

                            <div className="sender-radio-group">

                                <label className="sender-radio-option">

                                    <input
                                        type="radio"
                                        name="templateType"
                                        value="promotional"
                                        checked={
                                            templateType ===
                                            "promotional"
                                        }
                                        onChange={() =>
                                            settemplateType(
                                                "promotional"
                                            )
                                        }
                                    />

                                    <span className="custom-radio">
                                        <span />
                                    </span>

                                    <span>
                                        Promo
                                    </span>

                                </label>


                                <label className="sender-radio-option">

                                    <input
                                        type="radio"
                                        name="templateType"
                                        value="Impicit"
                                        checked={
                                            templateType ===
                                            "Impicit"
                                        }
                                        onChange={() =>
                                            settemplateType(
                                                "Impicit"
                                            )
                                        }
                                    />

                                    <span className="custom-radio">
                                        <span />
                                    </span>
                                    <span>
                                        Service Impicit
                                    </span>


                                </label>

                                <label className="sender-radio-option">

                                    <input
                                        type="radio"
                                        name="templateType"
                                        value="Explicit"
                                        checked={
                                            templateType ===
                                            "Explicit"
                                        }
                                        onChange={() =>
                                            settemplateType(
                                                "Explicit"
                                            )
                                        }
                                    />

                                    <span className="custom-radio">
                                        <span />
                                    </span>
                                    <span>
                                        Service Explicit
                                    </span>


                                </label>

                            </div>

                        </div>

                        {/* USER + SENDER */}
                        <div className="template-row">



                            {/* <div className="template-field">
                                <label>User ID</label>

                                <select
                                    name="userId"
                                    value={formData.userId}
                                    onChange={handleChange}
                                >
                                    <option value="">
                                        Select User ID
                                    </option>
                                    <option value="USER001">
                                        USER001
                                    </option>
                                    <option value="USER002">
                                        USER002
                                    </option>
                                    <option value="USER003">
                                        USER003
                                    </option>
                                </select>
                            </div> */}

                            <div className="template-field">
                                <label>Sender ID</label>

                                <select
                                    name="senderId"
                                    value={formData.senderId}
                                    onChange={handleChange}
                                >
                                    <option value="">
                                        Select Sender ID
                                    </option>

                                    {senderAPIData?.map((item) => (
                                        <option
                                            key={item.autosnid}
                                            value={item.sender}
                                        >
                                            {item.sender}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="template-field">
                                <label>Entity ID</label>

                                <input
                                    type="text"
                                    value={
                                        senderAPIData?.find(
                                            (item) => item.sender === formData.senderId
                                        )?.peid || ""
                                    }
                                    readOnly
                                    placeholder="Select Sender ID"
                                    className={
                                        !formData.senderId
                                            ? "disabled-input"
                                            : ""
                                    }
                                />
                            </div>
                        </div>


                        {/* ENTITY + TEMPLATE NAME */}
                        <div className="template-row">



                            <div className="template-field">
                                <label>Template Name</label>

                                <input
                                    type="text"
                                    name="templateName"
                                    value={formData.templateName}
                                    onChange={handleChange}
                                    placeholder="Enter Template Name"
                                />
                            </div>

                            <div className="template-field">
                                <label>Template ID</label>

                                <input
                                    type="text"
                                    name="templateId"
                                    value={formData.templateId}
                                    onChange={handleChange}
                                    placeholder="Enter Template ID"
                                />
                            </div>
                        </div>





                        {/* TEMPLATE TEXT */}
                        <div className="template-field full-width">
                            <label>Template Text</label>

                            <textarea
                                name="templateText"
                                value={formData.templateText}
                                onChange={handleChange}
                                placeholder="Enter Template Text"
                                rows="3"
                            />
                        </div>

                        <div className="sender-form-actions" style={{ marginTop: "1.5rem" }}>

                            <button
                                type="submit"
                                className="sender-submit-btn"
                                onClick={handleSubmit}
                            >
                                <i className="fa fa-check" />
                                Submit
                            </button>

                            <button
                                type="button"
                                className="sender-cancel-btn"
                                onClick={
                                    handleCancel
                                }
                            >
                                Cancel
                            </button>

                        </div>

                    </div>
                </div>


                {/* ================= BULK UPLOAD ================= */}
                <div className="template-card">

                    <div className="template-card-title">
                        Whitelisting Template
                        <span>[ Bulk Upload ]</span>
                    </div>

                    <div className="template-card-body">


                        {/* <div className="bulk-file-type">

                            <label className="bulk-label">
                                File Type:
                            </label>

                            <label className="radio-option">
                                <input
                                    type="radio"
                                    name="fileType"
                                    checked={fileType === "CSV"}
                                    onChange={() =>
                                        setFileType("CSV")
                                    }
                                />
                                <span>CSV</span>
                            </label>

                            <label className="radio-option">
                                <input
                                    type="radio"
                                    name="fileType"
                                    checked={fileType === "XLSX"}
                                    onChange={() =>
                                        setFileType("XLSX")
                                    }
                                />
                                <span>XLSX</span>
                            </label>

                        </div> */}

                        <div className="sender-form-group template-field">
                            <label>
                                File Type
                            </label>

                            <div className="sender-radio-group">
                                <label className="sender-radio-option">

                                    <input
                                        type="radio"
                                        name="fileType"
                                        value="CSV"
                                        checked={
                                            fileType ===
                                            "CSV"
                                        }
                                        onChange={() =>
                                            setFileType(
                                                "CSV"
                                            )
                                        }
                                    />

                                    <span className="custom-radio">
                                        <span />
                                    </span>
                                    <span>
                                        CSV
                                    </span>


                                </label>

                                <label className="sender-radio-option">

                                    <input
                                        type="radio"
                                        name="fileType"
                                        value="XLSX"
                                        checked={
                                            fileType ===
                                            "XLSX"
                                        }
                                        onChange={() =>
                                            setFileType(
                                                "XLSX"
                                            )
                                        }
                                    />

                                    <span className="custom-radio">
                                        <span />
                                    </span>
                                    <span>
                                        XLSX
                                    </span>


                                </label>

                            </div>

                        </div>

                        {/* <div className="template-row">

                            <div className="template-field">
                                <label>User ID</label>

                                <select
                                    name="userId"
                                    value={bulkData.userId}
                                    onChange={handleBulkChange}
                                >
                                    <option value="">
                                        Select User ID
                                    </option>
                                    <option value="USER001">
                                        USER001
                                    </option>
                                    <option value="USER002">
                                        USER002
                                    </option>
                                    <option value="USER003">
                                        USER003
                                    </option>
                                </select>
                            </div>

                            <div className="template-field">
                                <label>Operator Name</label>

                                <select
                                    name="operatorId"
                                    value={bulkData.operatorId}
                                    onChange={handleBulkChange}
                                >
                                    <option value="">
                                        Select Operator ID
                                    </option>
                                    <option value="OP001">
                                        OP001
                                    </option>
                                    <option value="OP002">
                                        OP002
                                    </option>
                                </select>
                            </div>

                        </div> */}


                        {/* UPLOAD */}
                        <div className="template-field full-width">

                            <label>Upload File</label>

                            <label className="sender-upload-box">

                                <input
                                    type="file"
                                    accept={
                                        fileType === "CSV"
                                            ? ".csv"
                                            : ".xlsx,.xls"
                                    }
                                    onChange={handleFileChange}
                                />

                                <div className="sender-upload-icon">
                                    <i className="fa fa-cloud-upload-alt" />
                                </div>

                                <div className="sender-upload-title">
                                    {bulkData.file
                                        ? bulkData.file.name
                                        : "Click to upload file"}
                                </div>

                                <div className="sender-upload-hint">
                                    {fileType === "CSV"
                                        ? "CSV file supported"
                                        : "XLSX / XLS file supported"}
                                </div>

                            </label>



                        </div>


                        {/* BUTTONS */}


                        <div className="sender-form-actions" style={{ marginTop: "1.5rem" }}>

                            <button
                                type="submit"
                                className="sender-submit-btn"
                            >
                                <i className="fa fa-check" />
                                Submit
                            </button>

                            <button
                                type="button"
                                className="sender-cancel-btn"
                                onClick={
                                    handleCancel
                                }
                            >
                                Cancel
                            </button>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
};

export default TemplateWhitelist;